import React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useAcrissGroups, useAcrissGroupsValidator } from "Pages/User/Settings/AcrissGroupTab/@hooks"
import { acrissGroupFormData } from "Pages/User/Settings/AcrissGroupTab/@signals"


export default function AcrissGroupDrawerName() {
	const { handleChangeFormData } = useAcrissGroups()
	const { nameError } = useAcrissGroupsValidator()

	return <TextFieldSeeker
		error={nameError}
		placeholder="Group name"
		value={acrissGroupFormData.value?.name || ''}
		onChange={e => handleChangeFormData(e.target.value, 'name')}
	/>
}
